import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {ButtonModel} from '../button-group/button-group.component'
import {SimpleValueAccessorSupportComponent} from '../../../util/angular/simple-value-accessor'

export interface RadioButton<T extends string> {
  etykieta: string,
  nazwa: T
}

@Component({
  templateUrl: './radio-button-base.component.html',
})
export class RadioButtonBaseComponent<T extends string> extends SimpleValueAccessorSupportComponent<RadioButton<T>> implements OnInit {

  @Input()
  radioButtons: RadioButton<T>[] = []

  @Output()
  buttonClick = new EventEmitter<ButtonModel>()

  buttons: ButtonModel[] = []

  ngOnInit(): void {
    if (this.radioButtons) {
      this.buttons = this.radioButtons.map((radioButton) => {
        return {
          name: radioButton.nazwa,
          label: radioButton.etykieta
        }
      })
    }
  }

  // eslint-disable  @typescript-eslint/no-non-null-assertion
  buttonClicked($event: ButtonModel): void {
    this.value = {
      etykieta: $event.label!,
      nazwa: $event.name! as T
    }
    this.onChange(this.value)
    this.buttonClick.emit($event)
  }
}
